import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Modal from 'react-modal';
import 'bootstrap/dist/css/bootstrap.min.css';

//import registerServiceWorker from './registerServiceWorker';
//import unregister from './registerServiceWorker';
document.addEventListener("DOMContentLoaded", init);
function init() {
    const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
/*    const baseUrl = document.URL;*/
    const rootElement = document.getElementById('root');
    Modal.setAppElement(rootElement);
    ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>,
        rootElement);
}

//unregister();


// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//



